import React, { useEffect, useState } from 'react';
import MyGoogleMap from 'components/Common/Maps/MyGoogleMap';
import { PropTypes } from 'prop-types';
import * as Yup from 'yup';
import { useNibbleForm } from 'components/Nibble/Hooks/UseNibbleForm';
import { Alert, Button, Card, CardBody, Form, Offcanvas, OffcanvasBody, OffcanvasHeader, Row } from 'reactstrap';

import { MEXICO_STATES } from 'helpers/states';
import { getProducts, postBranche, postDelivery, putBranch, putDevelivery } from 'helpers/backend_helper';

const cpRegExp = /^[0-9]{5}/;

const Branches = ({ model, setModel }) => {
    const [curAddress, setCurAddress] = useState({
        country: 'México',
    })
    const [offCanvasIsOpen, setOffCanvasIsOpen] = useState(false)
    const [error, setError] = useState("")
    const [completed, setCompleted] = useState("")
    const [btnSaveLoad, setBtnSaveLoad] = useState(false)
    const [position, setPosition] = useState(null)
    const [selectedRegion, setSelectedRegion] = useState(model.invoice_address?.region_id)
    const [products, setProducts] = useState([])

    const addFarm = (indexFarm, edit = false) => {
        let farm = { ... (indexFarm != null ? model.farms[indexFarm] : {}) }
        if (farm) {
            delete farm?.address?.enterprise_id
        }
        farm = { ...farm.address, ...farm, gps: farm.address?.gps || null }
        farm.edit = edit
        farm.indexItem = indexFarm
        setCurAddress(farm)
        //setPosition(farm?.gps ? { lat: farm?.gps.split(",")[0], lng: farm?.gps.split(",")[1] } : null)
        setOffCanvasIsOpen(true)
    }

    const delFarm = indexFarm => {
        // Delete Farm
    }

    const toggleRightCanvas = () => {
        setCompleted(null)
        setOffCanvasIsOpen(!offCanvasIsOpen)
    }

    const { validation, render } = useNibbleForm({
        formScheme: [
            { md: 12, name: 'name', label: 'Nombre', type: 'text' },
            { md: 12, name: 'street', label: 'Calle', type: 'text' },
            { md: 4, name: 'ext_num', label: 'Num. Ext.', type: 'text' },
            { md: 4, name: 'int_num', label: 'Num. Int.', type: 'text' },
            { md: 4, name: 'cp', label: 'C.P.', type: 'text' },
            { md: 6, name: 'location', label: 'Colonia', type: 'text' },
            { md: 6, name: 'city', label: 'Ciudad/Municipio', type: 'text' },
            { md: 6, name: 'state', label: 'Estado', type: 'select', selectItems: MEXICO_STATES, selectOptionValue: (option) => `${option.name}` },
            { md: 6, name: 'country', label: 'País', type: 'text', disabled: true },
            { md: 6, name: 'label', label: '¿Entrega en sucursal?', type: 'hidden' },
            { md: 6, name: 'local_delivery', label: 'Sí', type: 'checkbox-single' },
            { md: 12, name: 'regions', label: 'Zonas de cobertura', type: 'multi-select', selectItems: MEXICO_STATES, selectOptionValue: (option) => `${option.name}` },
            { md: 12, name: 'products', label: 'Productos', type: 'multi-select', selectItems: products },
            { md: 12, name: 'gps', label: 'Ubicación GPS', type: 'text', disabled: true },
            { md: 12, name: 'goo_address', label: null, type: 'hidden' },
        ],
        validationScheme: Yup.object().shape({
            name: Yup.string().required('Requerido'),
            street: Yup.string().required('Requerido'),
            ext_num: Yup.string().required('Requerido'),
            int_num: Yup.string().nullable(),
            cp: Yup.string().matches(cpRegExp, 'Código postal no válido').required('Requerido'),
            location: Yup.string().required('Requerido'),
            city: Yup.string().required('Requerido'),
            state: Yup.string().required('Requerido'),
            country: Yup.string().required('Requerido'),
        }),
        defaultModelValues: {
            country: 'México',
            address: {},
            local_delivery: false,
            region_id: null,
            region: null,
            regions: [],
            gps: null,
        },
        model: curAddress,
        onSubmit: async (values) => {
            console.log('values', values)
            setCurAddress({ ...curAddress, ...values })
            setBtnSaveLoad(true)
            try {
                const obj = JSON.parse(localStorage.getItem("authUser"))
                console.log('user', obj.user);
                console.log('modelo', { id: model.id, ...values })

                let newModel = {}
                let payload = {
                    ...values,
                    address: {
                        street: values.street,
                        ext_num: values.ext_num,
                        int_num: values.int_num,
                        location: values.location,
                        city: values.city,
                        state: MEXICO_STATES.find(s => s.id == values.state)?.name || values.state,
                        country: values.country,
                        cp: values.cp,
                        gps: values.gps,
                        goo_address: values.goo_address,
                        region_id: selectedRegion,
                    },
                }
                if ('indexItem' in curAddress && curAddress.indexItem != null) {
                    const response = await putBranch(model.id, { id: curAddress.id, ...payload, region_id: selectedRegion })
                    newModel = { ...model }
                    newModel.farms[curAddress.indexItem] = response;
                } else {
                    const response = await postBranche(model.id, { ...payload, region_id: selectedRegion })
                    newModel = { ...model }
                    newModel.farms.push(response)
                    toggleRightCanvas()
                }

                setModel(newModel)
                setError(null)
                setCompleted('Se completo la operación')
            } catch (error) {
                console.log(error)
                setError(error.toString())
                setCompleted(null)
            }
            setBtnSaveLoad(false)
        }
    });

    useEffect(() => {
        getProducts().then(setProducts)
    }, [])

    return (
        <>
            <Card>
                <CardBody>
                    <table className="table table-responsive table-bordered table-sm">
                        <thead>
                            <tr className='bg-light'>
                                <th>Sucursal</th>
                                <th>Entrega en sucursal</th>
                                <th>Región de sucursal</th>
                                <th>Zonas de cobertura</th>
                                <th>Productos</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(model.farms || []).map((farm, key) => (
                                <tr key={key}>
                                    <td>{farm.name}</td>
                                    <td>{farm.local_delivery ? "Sí" : "No"}</td>
                                    <td>{farm.region ? farm.region.name : ""}</td>
                                    <td>
                                        {farm.regions
                                            ? farm.regions.reduce((prev, cur) => {
                                                return (
                                                    prev +
                                                    ("label" in cur ? cur.label : cur.name) +
                                                    " - "
                                                )
                                            }, "")
                                            : ""}
                                    </td>
                                    <td>
                                        {farm.products.map(prod => prod.name).join(", ")}
                                    </td>
                                    <td>
                                        <Button
                                            type="button"
                                            className="btn btn-warning btn-sm"
                                            onClick={() => addFarm(key, true)}
                                        >
                                            <i className="fas fa-edit"></i>
                                        </Button>{" "}
                                        <Button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => delFarm(key)}
                                        >
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>

                            ))}
                            {model.deliveries_address?.length == 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center">Sin Sucursales</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={6} className="text-center">
                                    <Button type="button" className="btn btn-danger btn-sm" onClick={() => addFarm()}>
                                        <i className="fas fa-plus"></i> Agregar sucursal
                                    </Button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </CardBody>
            </Card>
            <Offcanvas
                isOpen={offCanvasIsOpen}
                direction="end"
                toggle={toggleRightCanvas}
            >
                <OffcanvasHeader toggle={toggleRightCanvas}>
                    {'edit' in curAddress && curAddress.edit ? 'Modificar sucursal' : 'Nueva sucursal'}
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            console.log('submit');
                            e.preventDefault();
                            validation.handleSubmit(e)
                            return false;
                        }}
                    >
                        {error ? <Alert color="danger">{error}</Alert> : null}
                        {completed ? <Alert color="success">{completed}</Alert> : null}
                        <Row>
                            {
                                //JSON.stringify(position)
                            }
                            {render()}
                        </Row>

                        <MyGoogleMap
                            validation={validation}
                            setPosition={setPosition}
                            setAddress={newAddress => {
                                validation.setFieldValue('goo_address', newAddress)
                            }}
                            startPosition={
                                validation.values?.address?.gps
                                    ? {
                                        lat: Number(validation.values.address?.gps.split(",")[0]),
                                        lng: Number(validation.values.address?.gps.split(",")[1]),
                                    }
                                    : null
                            }
                        />

                        <div className="text-center mt-3">
                            <button type="submit" className="btn btn-sm btn-danger w-md" disabled={btnSaveLoad}>
                                <i className="fas fa-save"></i> Guardar
                            </button>
                            <button type="button" className="btn btn-sm btn-danger w-md ms-2" disabled={btnSaveLoad} onClick={toggleRightCanvas}>
                                <i className="fas fa-reply"></i> Cerrar
                            </button>
                        </div>
                    </Form>
                </OffcanvasBody>
            </Offcanvas>
        </>
    );
};

Branches.propTypes = {
    model: PropTypes.object.isRequired,
    setModel: PropTypes.func.isRequired,
};

export default Branches;